import { Flex, Typography } from "antd"
import React, { useState } from "react"

import { empty } from "../../../constants/placeholders"
import { useDateFormat } from "../../../hooks/use-date-format.ts"
import { calendarDeepLink } from "../../Calendar/helpers/calendar-deep-link.ts"
import { CalendarIcon } from "../../Lead/icons/lead-state-icons.tsx"
import { ActivityQuickDetailsPopover } from "./ActivityQuickDetails/ActivityQuickDetailsPopover.tsx"
import { formatFollowUp } from "../helpers/lead-table-format.ts"

const { Text } = Typography

/** Matches the "scheduled" follow-up reading — an appointment is always a
 *  future booking, never overdue the way a follow-up call can be. */
const APPOINTMENT_COLOR = "#2563EB"

interface LeadAppointmentCellProps {
  date?: string | null
  time?: string | null
  eventId?: string | null
  onEdit?: () => void
}

export function LeadAppointmentCell({
  date,
  time,
  eventId,
  onEdit
}: LeadAppointmentCellProps) {
  const { userFormat, normalizeDate } = useDateFormat()
  const [open, setOpen] = useState(false)
  if (!date) return <>{empty}</>

  const label = formatFollowUp(date, time, { userFormat })
  if (!label) return <>{empty}</>

  const calendarHref = calendarDeepLink(normalizeDate(date), eventId)

  return (
    <ActivityQuickDetailsPopover
      kind={"appointment"}
      eventId={eventId}
      fallbackDateLabel={label}
      calendarHref={calendarHref}
      open={open}
      onOpenChange={setOpen}
      onEdit={onEdit}
    >
      <Flex align={"center"} gap={6} className={"cursor-pointer"}>
        <CalendarIcon
          className={"shrink-0 text-sm"}
          style={{ color: APPOINTMENT_COLOR }}
        />
        <Text ellipsis={{ tooltip: label }}>{label}</Text>
      </Flex>
    </ActivityQuickDetailsPopover>
  )
}
